import { $api } from '../y/api';
import { YId } from '../y/types';

export interface FAssetGroup {
    key: string;
    name: string;
}

export type FAssetKind = 'image' | 'font';

export interface FAsset {
    group_key: string;
    key: string;
    name: string;
    kind: FAssetKind;
    object_id: YId;
    width: number;
    height: number;
    aspect: number;
    duration: number;
}

export function fAssetGroupsGetAll() {
    return $api.GET<FAssetGroup[]>('f/asset_groups');
}

export function fAssetsGetAll() {
    return $api.GET<FAsset[]>('f/assets');
}

export function fAssetGroupCreate(item: FAssetGroup) {
    return $api.POST<FAssetGroup>('f/asset_group', item);
}

export function fAssetCreate(item: FAsset) {
    return $api.POST<FAsset>('f/asset', item);
}

